import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PromoInterface } from 'types';

export type PackagesStore = {
  isLoadingPromo: boolean;
  errorMsg: string;
  packagesPromo: PromoInterface | null;
};

const initialState: PackagesStore = {
  isLoadingPromo: false,
  errorMsg: '',
  packagesPromo: null
};

export const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setIsLoadingPromo: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPromo = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setPackagesPromo: (state, action: PayloadAction<PromoInterface>) => {
      state.packagesPromo = action.payload;
    }
  }
});

export const { setIsLoadingPromo, setError, setPackagesPromo } =
  packagesSlice.actions;

export default packagesSlice.reducer;
